import { Slot } from '@radix-ui/react-slot'
import React from 'react'

import { useNumberMask } from './useNumberMask'

interface NumberMaskProps {
  children: React.ReactNode;
  decimalPlaces?: number;
}

export function NumberMask ({ children, decimalPlaces = 2 }: NumberMaskProps) {
  const { ref } = useNumberMask({ decimalPlaces })

  return (
    <Slot inputMode='decimal' ref={ref}>
      {children}
    </Slot>
  )
}
